import { Injectable } from '@angular/core';
import { makeUniqueStringArray } from '../utility/array.utility';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storageKey = 'searchValues';

  /**
   * Retrieves and returns an array of search values stored in the local storage.
   * The values are parsed from a JSON string and returned in reverse order.
   * If no values are found, an empty array is returned.
   *
   * @return {string[]} An array of search values retrieved from the local storage in reverse order.
   *                    Returns an empty array if no values are found.
   */
  getSearchValues(): string[] {
    const values = localStorage.getItem(this.storageKey);
    const allValues = values ? JSON.parse(values) : [];
    if (!allValues || !Array.isArray(allValues) || allValues.length === 0)
      return [];
    return makeUniqueStringArray(
      allValues.filter(val => {
        return val !== undefined && val !== null && val !== '';
      })
    ).reverse();
  }

  /**
   * Adds a search value to the stored list of search values if it does not already exist.
   *
   * @param {string} value - The search value to be added.
   * @return {void} This method does not return a value.
   */
  addSearchValue(value: string): void {
    console.log('add value...', value);
    const values = this.getSearchValues();
    if (!values.includes(value)) {
      values.push(value);
      localStorage.setItem(this.storageKey, JSON.stringify(values));
    }
  }

  /**
   * Clears the stored search values by removing the corresponding item from localStorage.
   *
   * @return {void} Does not return any value.
   */
  clearSearchValues(): void {
    localStorage.removeItem(this.storageKey);
  }
}
